
import $ from 'jquery';
export const appName = 'W';


var msgModel = [];
msgModel['ERR0000'] = 'Unidentified Error. Please contact to administrator';
msgModel['MSG0000'] = 'SUCCESS';
msgModel['MSG0001'] = 'Invalid username or password.';
msgModel['MSG0002'] = 'Session has been expired. Please login again.';
msgModel['MSG0003'] = 'User is inactive.';
msgModel['MSG0004'] = 'User is blocked by Admin or Head office.';
msgModel['MSG0005'] = 'Please check password policy.';
msgModel['MSG0006'] = 'Please fill mandatory feilds.';
msgModel['MSG0007'] = 'Date of birth sould be less than today.';
msgModel['MSG0008'] = 'Payment does not tally. Please check.';
msgModel['MSG0009'] = 'New password and confirm password does not match.';
msgModel['MSG0011'] = 'Please update to latest version.';
msgModel['MSG0012'] = 'Please press CTRL F5.';

var demoSetup = true;
if ((window.location.hostname).includes('localhost') || (window.location.hostname).includes('demo.zeneremit.com')) {
    demoSetup = true;

}
//demoSetup = false;
export const showPickList = demoSetup;   // Integration with ZenithFX
console.log(demoSetup);
//export const showPickList = true;   // Integration with ZenithFX

export const getMessage = (key) => {
    return msgModel[key];
}

export const apiBasePath = "";
/*export const apiBasePath = "http://localhost:1001";*/ // same
//export const apiBasePath = "http://localhost:2001"; // cross domain

export const apiPicklist = apiBasePath + "/api/picklist_a.php";
export const apiLogin = apiBasePath + "/api/login_a.php";
export const apiUser = apiBasePath + "/api/user_a.php";
export const apiCountry = apiBasePath + '/api/country_a.php';
export const apiState = apiBasePath + '/api/state_a.php';
export const apiCity = apiBasePath + '/api/city_a.php';
export const apiIsd = apiBasePath + '/api/isd_a.php';
export const apiIssuer = apiBasePath + '/api/issuer_a.php';
export const apiEntity = apiBasePath + '/api/entity_a.php';
export const apiEntityContract = apiBasePath + '/api/entity_contract_a.php';
export const apiRightGroup = apiBasePath + '/api/right_group_a.php';
export const apiRight = apiBasePath + '/api/right_a.php';
export const apiProduct = apiBasePath + '/api/product_a.php';
export const apiProductType = apiBasePath + '/api/product_type_a.php';
export const apiPurpose = apiBasePath + '/api/purpose_a.php';
export const apiPanRelation = apiBasePath + '/api/pan_relation_a.php';
export const apiRate = apiBasePath + '/api/rate_a.php';
export const apiNewRequest = apiBasePath + '/api/newrequest_a.php';
export const apiRequestStatus = apiBasePath + '/api/req_status_a.php';
export const apiInProgress = apiBasePath + '/api/in_progress_a.php';
export const apiCover = apiBasePath + '/api/cover_a.php';
export const apiCharges = apiBasePath + '/api/charges_a.php';
export const apiAddDetails = apiBasePath + '/api/add_details_a.php';
export const apiBank = apiBasePath + '/api/bank_a.php';
export const apiUploadFile = apiBasePath + '/api/upload_a.php';
export const apiBackoffice = apiBasePath + '/api/backoffice_a.php';
export const apiPaymentApprove = apiBasePath + '/api/payment_approval_a.php';
export const apiComment = apiBasePath + '/api/comment_a.php';
export const apiComplianceApprove = apiBasePath + '/api/compliance_approve_a.php';
export const apiBankFile = apiBasePath + '/api/bank_file_a.php';
export const apiDetails4Pg = apiBasePath + '/api/details4pg_a.php';
export const apiPgPine = apiBasePath + '/api/pg/pg_pine_a.php';
export const apiPgResponse = apiBasePath + '/api/pg/pg_response_a.php';
export const apiReport = apiBasePath + '/api/report_a.php';
export const apiCashFree = apiBasePath + '/api/cashfree_a.php';
export const apiEnquiry = apiBasePath + '/api/enquiry_a.php';
export const apiInward = apiBasePath + '/api/inward_a.php';
export const apiFormat = apiBasePath + '/api/format_a.php';
export const apiIdfcRemit = apiBasePath + '/api/idfc_remitapi_a.php';
export const apiReconciliationActivity = apiBasePath + '/api/reconciliation_activity_a.php';
export const apiInvoiceEmailReq = apiBasePath + '/api/autoinvoicereq_a.php';
export const apiSpecialApproval = apiBasePath + '/api/special_approval_a.php';
export const apiEntityLocation = apiBasePath + '/api/entity_location_a.php';
export const apiBooking = apiBasePath + '/api/booking_a.php';
export const apiIndividualProfile = apiBasePath + '/api/individual_profile_a.php';
export const apiIdtype = apiBasePath + '/api/idtype_a.php';
export const apiRisk = apiBasePath + '/api/risk_a.php';
export const apiUtr = apiBasePath + '/api/utr_a.php';
export const apiAd1 = apiBasePath + '/api/ad1_a.php';
export const apiad1coverrate = apiBasePath + '/api/ad1coverrate_a.php';
export const apiNewRequestCnCard = apiBasePath + '/api/newrequest_cncard_a.php';
export const apiAD1Comment = apiBasePath + '/api/AD1comment_a.php';
export const apiAD2Modification = apiBasePath + '/api/ad2Modification.php';
export const apiCommissionChangeAllowed = apiBasePath + '/api/commission_change_allowed_a.php';
export const apiBankCharges = apiBasePath + '/api/bank_charges_a.php';
export const apiAWS = apiBasePath + "/api/aws_a.php";



//export const validEmail = new RegExp( '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'  );
export const validPassword = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,20}$');
//      '^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$'
//     '/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/';
const apiCommon = apiBasePath + '/api/common_a.php';





export const removeSpecialChar = (getString) => {
    if (typeof getString != 'number' && getString != null) {
        getString = getString.replace(/\&amp;/g, "and");
        getString = getString.replace(/\&/g, "and");
        getString = getString.replace(/\$/g, " ");
        getString = getString.replace(/\#/g, " ");
        getString = getString.replace(/\*/g, " ");
        getString = getString.replace(/\</g, " ");
        getString = getString.replace(/\>/g, " ");
        getString = getString.replace(/\-/g, " ");
        getString = getString.replace(/\_/g, " ");
        getString = getString.replace(/\+/g, " ");
        getString = getString.replace(/\%/g, " ");
    }
    return getString;
}

function replaceSpecialChar(getString) {
    if (typeof getString != 'number' && getString != null) {
        getString = getString.replace(/\#/g, "^^hash^^");
        getString = getString.replace(/\+/g, "^^plus^^");
        getString = getString.replace(/\%/g, "^^mod^^");
        getString = getString.replace(/\&amp;/g, "^^and^^");
        getString = getString.replace(/\&/g, "^^and^^");
    }
    return getString;
}

function ajaxRequest() {
    if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
        return new XMLHttpRequest();
    }
}

export const callApi = (url, prm, Success) => {
    var prms = "";
    if (typeof (prm) != "undefined") {
        for (let i = 0; i < prm.length; i++) {
            if (prms.length > 0) prms = prms + "&";
            prms = prms + (i + 1) + '=' + replaceSpecialChar(prm[i]);
        }
    }
    var xhr = new ajaxRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            var SessXML = xhr.responseText.replace(/[\r\n\s]*</g, "<").replace(/[\r\n\s]*$/g, "");

            if (SessXML.indexOf(".php") >= 0) {
                alert(SessXML);
                //$('.loader').hide();
            }
            else if (SessXML === '{"status": "MSG0002"}') {
                sessionStorage.clear();
                const myLoc = window.location.href.split('/');
                window.location.replace(myLoc[0] + '//' + myLoc[2] + '/');
            }
            else {
                Success(SessXML);
            }
        }
    }
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(prms);
}

// Input field Validations
const alpRegExp = new RegExp('^([a-zA-Z ]+)$');
export const validateAlpValue = (e, f) => {
    if (e === "" || alpRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const intRegExp = new RegExp('^([0-9]+)$');
export const validateNumValue = (e, f) => {
    if (e === "" || intRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const floatRegExp = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
export const validateDecValue = (e, f) => {
    if (e === "" || floatRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const negativeFloatRegExp = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$')
export const validateDecValueNegative = (e, f) => {
    if (e === "" || e === "-" || negativeFloatRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const alpNumRegExpWS = new RegExp('^([0-9a-zA-Z]+)$');
export const validateAlpNumWSValue = (e, f) => {
    if (e === "" || alpNumRegExpWS.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const alpNumRegExp = new RegExp('^([0-9a-zA-Z ]+)$');
export const validateAlpNumValue = (e, f) => {
    if (e === "" || alpNumRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}



const alpNumSpl1RegExp = new RegExp('^([0-9a-zA-Z- ]+)$');
export const validateAlpNumSpl1Value = (e, f) => {
    if (e === "" || alpNumSpl1RegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}
const alpNumSplRegExp = new RegExp('^([0-9a-zA-Z/-_!@$^*()#%& ]+)$');
export const validateAlpNumSplValue = (e, f) => {
    if (e === "" || alpNumSplRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const alpNumPanRegExp = new RegExp("^([0-9a-zA-Z.' ]+)$");
export const validateAlpNumPAN = (e, f) => {
    if (e === "" || alpNumPanRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

//const emailRegExp = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9]+[.]+[A-Za-z]+$');
const emailRegExp = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[A-Za-z]{2,}$');
export const validtateEmail = (e, f) => {
    if (e === "" || emailRegExp.test(e)) {
        f(e);
    } else {
        f("");
    }
}
const panRegExp = new RegExp('^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$');
export const validatePan = (e, f) => {
    e = e.toUpperCase();
    var letter4_valid = /([A,B,C,F,G,H,J,L,P,T])/;
    var letter4 = e.substring(3, 4);
    if ((e === "" || panRegExp.test(e)) && (letter4_valid.test(letter4))) {
        f(e);
    } else {
        f("");
    }
}

export const validatePanFlag = (e) => {
    e = e.toUpperCase();
    var letter4_valid = /([A,B,C,F,G,H,J,L,P,T])/;
    var letter4 = e.substring(3, 4);
    if ((e === "" || panRegExp.test(e)) && (letter4_valid.test(letter4))) {
        return true;
    } else {
        return false;
    }
}

// Date Conversion
//---------------Change Date Format 
export const dateYMD = (dt) => {       // Convert To YYYY-MM-DD
    if (dt === "" || dt === null) {
        return dt;
    } else {
        var dtstr = dt.toString();
        dtstr = dtstr.replace("00:00:00 GMT+0530", "05:30:00 GMT+0530");
        dt = new Date(dtstr);
        return dt.toJSON().slice(0, 10);
    }
}

export const dateDMY = (dt) => {       // Convert to DD/MM/YYYY
    if (dt === "" || dt === null) {
        return dt;
    } else {
        return dt.toJSON().slice(0, 10).split('-').reverse().join('/');
    }
}
export const dateDMY_Minus = (dt) => {       // Convert to DD/MM/YYYY
    if (dt === "" || dt === null) {
        return dt;
    } else {
        return dt.toJSON().slice(0, 10).split('-').reverse().join('-');
    }
}

export const getFutureDateDMY = (offset = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const dateDMYStr = (dt) => {       // Convert to DD/MM/YYYY
    if (dt === "" || dt === null) {
        return dt;
    } else {
        return dt.slice(0, 10).split('-').reverse().join('/');
    }
}

// Associative array manupulations 

export const arrayRemoveItem = (arr, key, value) => {
    if (arr.length > 0) {
        for (var i = 0; i < arr.length; ++i) {
            if (arr[i][key] === value) {
                arr.splice(i, 1);
            }
        }
    }
    return arr;
}

export const arrayAddItem = (arr, obj) => {
    arr.push(obj);
    // console.log(JSON.stringify(arr,null,' ') );
    return arr;
}

export const arrayChangeItem = (arr, uKey, uValue, key, value) => {
    if (arr.length > 0) {
        for (var i = 0; i < arr.length; ++i) {
            if (arr[i][uKey] === uValue) {
                arr[i][key] = value;
            }
        }
    }
    // console.log(JSON.stringify(arr,null,' ') );
    return arr;
}

// RandomString Generator
export const getRandomString = () => {
    var a = (Math.random() + 1).toString(36).substring(2);
    var b = (Math.random() + 1).toString(36).substring(2);
    return a + b;
}

//formData.append('username', 'Chris');
//formData.append('userpic', myFileInput.files[0], 'chris.jpg');
//
export const uploadApi = (obj, fileId, Success) => {
    var myFile = document.getElementById(fileId);
    var files = myFile.files;
    var file = files[0];

    var formData = new FormData();
    formData.append('1', obj);
    formData.append('file', file, file.name);
    var xhr = new XMLHttpRequest();
    xhr.open("POST", apiUploadFile, true);
    xhr.onload = function () {
        if (xhr.status === 200) {
            var responseText = xhr.responseText.replace(/[\r\n\s]*</g, "<").replace(/[\r\n\s]*$/g, "");

            if (responseText.indexOf(".php") >= 0) {
                alert(responseText);
            } else {
                Success(responseText);
            }
            // Success('Upload complete!' + responseText);
        } else {
            Success('Upload error. Try again.');
        }
    }
    xhr.send(formData);
}
export const callDownloadApiPost = (path, method, prm) => {
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    form._submit_function_ = form.submit;

    for (var i = 1; i <= prm.length; i++) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", i);
        hiddenField.setAttribute("value", prm[i - 1]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form._submit_function_();
}


export const callDocumentViewApi = (url, prm, Success) => {
    var prms = "";
    if (typeof (prm) != "undefined") {
        for (let i = 0; i < prm.length; i++) {
            if (prms.length > 0) prms = prms + "&";
            prms = prms + (i + 1) + '=' + replaceSpecialChar(prm[i]);
        }
    }
    var xhr = new ajaxRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            Success(xhr.responseText);
        }
    }
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(prms);
}
export const buildDateFormat = (v, e) => {
    var len = v.length;
    if (len === 2 || len === 5) {
        e.value = v + '/';
    }
}

export const buildMessageFromArray = (prm) => {
    var msg = "", i = 0;
    if (typeof (prm) != "undefined") {
        for (; i < prm.length; i++) {
            if (prm[i] !== "") {
                msg = msg + "<div class='row'><div class='col-sm-12'>" + prm[i] + "</div></div>";
            }
        }
    }
    return msg;
}

export const setPageTitle = (v) => {
    if (v === 0) {
        document.title = "ZeneRemit";
        document.getElementById("ZenFavicon").href = "/favicon.ico";
    } else {
        document.title = "ZeneRemit ( " + v + " )";
        document.getElementById("ZenFavicon").href = "/faviconred.ico";
    }

    // document.getElementById("ZenFavicon").href = "%PUBLIC_URL%/favicon1.ico";
}

export const getPanRelationCode = (v) => {
    var r = "0";
    switch (v.toUpperCase()) {
        case "SELF":
            r = "1";
            break;
        case "HUSBAND":
            r = "2";
            break;
        case "WIFE":
            r = "3";
            break;
        case "SON":
            r = "4";
            break;
        case "DAUGHTER":
            r = "5";
            break;
        case "BROTHER":
            r = "6";
            break;
        case "SISTER":
            r = "7";
            break;
        case "FRIEND":
            r = "8";
            break;
        case "FATHER":
            r = "9";
            break;
        case "MOTHER":
            r = "10";
            break;
        case "OTHER":
            r = "11";
            break;
        default:
            r = "0";
    }
    return r;
}

export const getSrNoFromRefNo = (v) => {
    var refArray = v.split('/');
    var refArrayLength = refArray.length;
    var lastItem = refArray[refArrayLength - 1];
    var srno = lastItem.substring(1);
    return srno;
}

export function calcGSTAmount(taxableValue) {
    return (Math.round((taxableValue * 0.18) * 100) / 100);
}

export function calcGSTTaxableValue(fxamnt, totchrg) {
    var GSTTaxableValslab = [250, 60000, 100000, 1000000, 0.01, 0.005, 0.001, 1000, 5500];
    //var fxamnt = $('#txtPayFxAmnt').val() * 1;
    //var totchrg = $("#txtPayTotChrg").val() * 1;
    var policy = 2; // sessionStorage.gstpolicy * 1;
    var TaxableVal = 0;
    switch (policy) {
        case 1: // total fx and charges then calculate taxable
            if (fxamnt + totchrg > 0 && fxamnt + totchrg <= GSTTaxableValslab[2]) {
                TaxableVal = Math.round((fxamnt + totchrg) * GSTTaxableValslab[4] * 100) / 100;
            } else if (fxamnt + totchrg > GSTTaxableValslab[2] && fxamnt + totchrg <= GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[7] + Math.round((fxamnt + totchrg - GSTTaxableValslab[2]) * GSTTaxableValslab[5] * 100) / 100;
            } else if (fxamnt + totchrg > GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[8] + Math.round((fxamnt + totchrg - GSTTaxableValslab[3]) * GSTTaxableValslab[6] * 100) / 100;
            }
            break;
        case 2: // calculate taxable from fx then add charges
            if (fxamnt > 0 && fxamnt <= GSTTaxableValslab[2]) {
                TaxableVal = Math.round((fxamnt) * GSTTaxableValslab[4] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[2] && fxamnt <= GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[7] + Math.round((fxamnt - GSTTaxableValslab[2]) * GSTTaxableValslab[5] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[8] + Math.round((fxamnt - GSTTaxableValslab[3]) * GSTTaxableValslab[6] * 100) / 100;
            }

            break;
        case 3: // calculate taxable only from fx
            if (fxamnt > 0 && fxamnt <= GSTTaxableValslab[2]) {
                TaxableVal = Math.round((fxamnt) * GSTTaxableValslab[4] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[2] && fxamnt <= GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[7] + Math.round((fxamnt - GSTTaxableValslab[2]) * GSTTaxableValslab[5] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[8] + Math.round((fxamnt - GSTTaxableValslab[3]) * GSTTaxableValslab[6] * 100) / 100;
            }
            break;
    }
    if (TaxableVal < GSTTaxableValslab[0])
        TaxableVal = GSTTaxableValslab[0];
    if (TaxableVal > GSTTaxableValslab[1])
        TaxableVal = GSTTaxableValslab[1];
    if (policy == 2) {
        TaxableVal += totchrg;
    }
    return (Math.round(TaxableVal * 100) / 100);
}

// Validate GST--------------------------------------------
const gstRegExp = new RegExp('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$');
export const validateGST = (e, f) => {
    e = e.toUpperCase();
    if (e === "" || gstRegExp.test(e)) {
        f(e);
    } else {
        f("");
    }
}

// Validate Mobile Number-------------------------
const mobileNumberRegExp = new RegExp('^[6-9]{1}[0-9]{9}$');
export const validateMobileNumber = (e, f) => {
    if (e === "" || mobileNumberRegExp.test(e)) {
        f(e);
    } else {
        f("");
    }
}

// Validate Adhaar Number
const adhaarRegExp = new RegExp('^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$');
export const validateAdhaar = (e, f) => {
    e = e.toUpperCase();
    //var letter4 = e.substring(3, 4);
    if (e === "" || adhaarRegExp.test(e)) {
        f(e);
    } else {
        //f("");
        f(e);
    }
}

// Validate Passport 
const passportRegExp = new RegExp('^[A-Z][1-9]\\d\\s?\\d{4}[1-9]$');
export const validatePassport = (e, f) => {
    if (e === "" || passportRegExp.test(e)) {
        f(e);
    } else {
        f(e);
    }
}


//jitendra arya
export const callDownloadApiPost1 = (path, method, prm, Success) => {
    //set data in the form;
    var formData = new FormData();
    for (var i = 0; i < prm.length; i++) {
        formData.append(`${i + 1}`, prm[i]);
    }
    var xhr = new XMLHttpRequest();
    xhr.open(method, path, true);
    xhr.responseType = 'blob'; // Set response type as blob to handle binary data
    xhr.onload = function () {
        if (xhr.status === 200) {
            // Create a blob from the response
            const blob = xhr.response;
            console.log(blob)

            // Get the filename from the Content-Disposition header
            const contentDisposition = xhr.getResponseHeader('Content-Disposition');
            console.log(contentDisposition)
            let filename = "downloaded_file.xlsx"; // Default filename

            if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                const filenameMatch = contentDisposition.split("filename=");
                console.log(filenameMatch)
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            // Create a link element to download the file
            const url = window.URL.createObjectURL(blob);
            console.log(url)
            const link = document.createElement('a');
            console.log(link)
            link.href = url;
            link.setAttribute('download', filename);

            // Append the link to the document and trigger click to start download
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Optionally, call success callback
            Success && Success("File downloaded successfully");
        } else {
            console.error("Error during file download: ", xhr.statusText);
        }
    };

    xhr.onerror = function () {
        console.error("Error during XMLHttpRequest");
    };
    xhr.send(formData);
}
export const getLedgerByGroupAccount = async (right, group, account) => {
    let obj = {
        right: right,
        group: group,
        account: account
    };
    return new Promise((resolve, reject) => {
        callApi(apiCommon, [sessionStorage.getItem('sessionId'), 'ledgerByGroupAccount', JSON.stringify(obj)], function (result) {
            try {
                const resp = JSON.parse(result);
                resolve(resp[0]);
            } catch (err) {
                reject(err);
            }
        });
    });
}
export const getIndividualBySrnoID = async (right, srno, id) => {
    let obj = {
        right: right,
        srno: srno,
        id: id
    };
    return new Promise((resolve, reject) => {
        callApi(apiCommon, [sessionStorage.getItem('sessionId'), 'individualBySrnoID', JSON.stringify(obj)], function (result) {
            try {
                const resp = JSON.parse(result);
                resolve(resp[0]);
            } catch (err) {
                reject(err);
            }
        });
    });
}

export function getYmdHis() {
    const now = new Date();
    const pad = n => String(n).padStart(2, '0');
    return (
        now.getFullYear().toString() +
        pad(now.getMonth() + 1) +
        pad(now.getDate()) +
        pad(now.getHours()) +
        pad(now.getMinutes()) +
        pad(now.getSeconds())
    );
}

export async function uploadFiletoAWSbucket(url, file,sid) {
    try {
        // console.log("Uploading to AWS URL:", url);
        console.log("File details:", file.name, file.type, file.size);
        const resp = await fetch(url, {
            method: "PUT",
            body: file,
        });
        const respText = await resp.text();
         console.log("qwwwwwwqqq",resp);
        const responseData = {
            type: resp.type,
            url: resp.url,
            redirected: resp.redirected,
            status: resp.status,
            ok: resp.ok,
            statusText: resp.statusText,
            bodyUsed: resp.bodyUsed,
            headers: Object.fromEntries(resp.headers.entries())
        };
        
        console.log("qqqq",responseData);
        callApi(apiAWS, [sid, "printResponse", JSON.stringify(responseData)], async (result) => {
            // const resp = JSON.parse(result);
            // console.log(resp)
        });
        if (resp.ok) {
            return { ok: true, status: resp.status };
        } else {
            return { ok: false, status: resp.status, body: respText };
        }
    } catch (err) {
        console.error("AWS upload error:", err);
        return { ok: false, error: String(err) };
    }
}

  export  const viewUploadedDocument = (fullpath,sid,callback) => {
        const obj = {
            key: fullpath
        }
         $('.loader').show();
        callApi(apiAWS, [sid, "viewData", JSON.stringify(obj)], result => {
                const resp = JSON.parse(result);
                $('.loader').hide();
            callback(resp)
            // window.open(resp.url_path, "_blank");
        })

    }


   export const downloadUploadedDocument = (fullpath,sid) => {
    $('.loader').show();
    const obj = {
        key: fullpath
    };

    callApi(apiAWS, [sid, "downloadData", JSON.stringify(obj)], async (result) => {
        const resp = JSON.parse(result);
        $('.loader').hide();
        const response = await fetch(resp);
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);

        const url = new URL(resp);
        const fileName = url.pathname.split("/").pop();

        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(link.href);
    });
};